/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.loyalty.tier.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../../validate/validate_pb.js')

var google_type_money_pb = require('../../../../../google/type/money_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.loyalty = {};
proto.witbooking.backoffice.loyalty.tier = {};
proto.witbooking.backoffice.loyalty.tier.v1 = require('./loyalty_tier_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse>}
 */
const methodDescriptor_LoyaltyTierAPI_CreateLoyaltyTier = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/CreateLoyaltyTier',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest,
  proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse>}
 */
const methodInfo_LoyaltyTierAPI_CreateLoyaltyTier = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIClient.prototype.createLoyaltyTier =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/CreateLoyaltyTier',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_CreateLoyaltyTier,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIPromiseClient.prototype.createLoyaltyTier =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/CreateLoyaltyTier',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_CreateLoyaltyTier);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse>}
 */
const methodDescriptor_LoyaltyTierAPI_UpdateLoyaltyTier = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/UpdateLoyaltyTier',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest,
  proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse>}
 */
const methodInfo_LoyaltyTierAPI_UpdateLoyaltyTier = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIClient.prototype.updateLoyaltyTier =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/UpdateLoyaltyTier',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_UpdateLoyaltyTier,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIPromiseClient.prototype.updateLoyaltyTier =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/UpdateLoyaltyTier',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_UpdateLoyaltyTier);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse>}
 */
const methodDescriptor_LoyaltyTierAPI_DeleteLoyaltyTier = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/DeleteLoyaltyTier',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest,
  proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse>}
 */
const methodInfo_LoyaltyTierAPI_DeleteLoyaltyTier = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIClient.prototype.deleteLoyaltyTier =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/DeleteLoyaltyTier',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_DeleteLoyaltyTier,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIPromiseClient.prototype.deleteLoyaltyTier =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/DeleteLoyaltyTier',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_DeleteLoyaltyTier);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse>}
 */
const methodDescriptor_LoyaltyTierAPI_GetLoyaltyTier = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/GetLoyaltyTier',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest,
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse>}
 */
const methodInfo_LoyaltyTierAPI_GetLoyaltyTier = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIClient.prototype.getLoyaltyTier =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/GetLoyaltyTier',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_GetLoyaltyTier,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIPromiseClient.prototype.getLoyaltyTier =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/GetLoyaltyTier',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_GetLoyaltyTier);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse>}
 */
const methodDescriptor_LoyaltyTierAPI_GetLoyaltyTiersByBrand = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/GetLoyaltyTiersByBrand',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest,
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse>}
 */
const methodInfo_LoyaltyTierAPI_GetLoyaltyTiersByBrand = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIClient.prototype.getLoyaltyTiersByBrand =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/GetLoyaltyTiersByBrand',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_GetLoyaltyTiersByBrand,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIPromiseClient.prototype.getLoyaltyTiersByBrand =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/GetLoyaltyTiersByBrand',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_GetLoyaltyTiersByBrand);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse>}
 */
const methodDescriptor_LoyaltyTierAPI_ReorderLoyaltyTier = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/ReorderLoyaltyTier',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest,
  proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse>}
 */
const methodInfo_LoyaltyTierAPI_ReorderLoyaltyTier = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIClient.prototype.reorderLoyaltyTier =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/ReorderLoyaltyTier',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_ReorderLoyaltyTier,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIPromiseClient.prototype.reorderLoyaltyTier =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/ReorderLoyaltyTier',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_ReorderLoyaltyTier);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse>}
 */
const methodDescriptor_LoyaltyTierAPI_PromoteLoyaltyTier = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/PromoteLoyaltyTier',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest,
  proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest,
 *   !proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse>}
 */
const methodInfo_LoyaltyTierAPI_PromoteLoyaltyTier = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIClient.prototype.promoteLoyaltyTier =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/PromoteLoyaltyTier',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_PromoteLoyaltyTier,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPIPromiseClient.prototype.promoteLoyaltyTier =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.tier.v1.LoyaltyTierAPI/PromoteLoyaltyTier',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTierAPI_PromoteLoyaltyTier);
};


module.exports = proto.witbooking.backoffice.loyalty.tier.v1;

